import { DiffList, RoleLabel } from "./CompareBits";
import HtmlFrame from "./HtmlFrame";
import { unwrapStageOutput } from "./evalOutput";

export default function Step3Diff({ caseRow, baseModel, evalModel }) {
  const structured = caseRow?.diff?.structured;
  const monetary = structured?.monetaryFigures;
  const baseHtml = unwrapStageOutput(caseRow?.baselineOutputText).text;
  const evalHtml = unwrapStageOutput(
    caseRow?.candidate?.candidateOutputText,
  ).text;

  const hasFigureDiff =
    monetary?.onlyInBaseline?.length > 0 ||
    monetary?.onlyInCandidate?.length > 0;

  return (
    <div className="mse-step3-diff">
      {hasFigureDiff && (
        <div className="mse-difflists">
          <DiffList
            title="Dropped by Eval"
            values={monetary?.onlyInBaseline}
            tone="dropped"
          />
          <DiffList
            title="Added by Eval"
            values={monetary?.onlyInCandidate}
            tone="added"
          />
        </div>
      )}
      {structured?.monetaryFiguresChanged === false && (
        <div className="mse-diffsummary mse-diffsummary--good">
          <strong>Every dollar figure matches.</strong>
          <span className="mse-diffsummary__meta">
            Remaining differences are markup churn only.
          </span>
        </div>
      )}
      <div className="mse-side-by-side mse-html-pair">
        <div>
          <h4>
            <RoleLabel role="base" model={baseModel} />
          </h4>
          <HtmlFrame html={baseHtml} title="Base Step 3" />
        </div>
        <div>
          <h4>
            <RoleLabel role="eval" model={evalModel} />
          </h4>
          <HtmlFrame html={evalHtml} title="Eval Step 3" />
        </div>
      </div>
    </div>
  );
}
